export default "__VITE_ASSET__CowQsLvS__"